import { FC } from 'react'
import { ContactAddInfo } from '../../../../../../hooks/useContactAddInfo'
import TowInputText from '../../../../../UtilComponent/level_2/TowInputText'
import AddressInput from '../../../../../UtilComponent/level_3/AddressInput'

type Props = ContactAddInfo

const EditContactAddInfo: FC<Props> = (props) => {
  const {
    organizationInput,
    positionInput,
    departmentInput,
    // mobilePhoneInput,
    telExtensionInput,
    altEmailInput,
    faxInput,
  } = props.other

  const address = {
    ...props.address.state,
    ...props.address.setState,
  }


  return (
    <div className="stack">
      <TowInputText first={organizationInput} second={departmentInput} />
      <TowInputText first={positionInput} second={telExtensionInput} />
      <TowInputText first={altEmailInput} second={faxInput} />
      <AddressInput {...address} />
    </div>
  )
}

export default EditContactAddInfo
